import {
  MODEL_TYPE
} from './model_types'

export const PRODUCT_BOM_TYPE = {
  PRODUCT: 10,
  RESOURCE: 20
}

export const PRODUCT_BOM_TYPE_TO_MODEL_TYPE = {
  [PRODUCT_BOM_TYPE.PRODUCT]: MODEL_TYPE.PRODUCT,
  [PRODUCT_BOM_TYPE.RESOURCE]: MODEL_TYPE.RESOURCE
}
